module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.html
// module id = ./src/app/components/app/app.component.html
// module chunks = main